import { Component, computed, input } from '@angular/core';
import { DecimalPipe } from '@angular/common';

@Component({
    selector: 'r1-compass-app-activity-counts',
    imports: [DecimalPipe],
    templateUrl: './activity-counts.component.html',
    styleUrl: './activity-counts.component.scss',
})
export class ActivityCountsComponent {
    counts = input.required<Count[]>();
    countsSorted = computed(() => this.counts().sort((a, b) => (a.order < b.order ? 0 : 1)));
}

export type Count = {
    label: 'Records Created' | 'Records Updated' | 'Records Failed' | 'Records Rejected';
    order: number;
    value: number;
};
